<template>
  <span v-resize="checkMobile" data-testid="branches-page">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <v-card>
      <!-- <v-card-title>
        <h2>{{ $t("custom.branches") }}</h2>
      </v-card-title> -->
      <v-card-text>
        <v-card>
          <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('custom.search')"
              single-line
              clearable
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn small color="success" data-testid="branch-new-btn" @click="newBranchDialog = true">{{
              $t("custom.new_branch")
            }}</v-btn>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="branches"
            :search="search"
            :loading="isLoading"
            :loading-text="$t('custom.loading_table')"
            :items-per-page="20"
            mobile-breakpoint="100"
            :class="!isMobile ? '' : 'is-mobile'"
            :sort-by="['name']"
            :sort-desc="[true]"
            :footer-props="tableFooterProps([20, 50, 100, -1])"
          >
            <template slot="item" slot-scope="props">
              <tr :class="props.item.archived ? 'grey darken-2' : props.item.id == company.id ? 'success' : ''" :key="props.item.id">
                <td class="text-center">
                  {{ props.item.id }}
                </td>
                <td class="text-center">
                  {{ props.item.name }}
                </td>
                <td class="text-center">
                  {{ props.item.country }}
                </td>
                <td class="text-center">
                  {{ props.item.city }}
                </td>
                <td class="text-center">
                  {{ props.item.address }}
                </td>
                <td class="text-center">
                  <v-btn
                    v-if="props.item.id != company.id"
                    color="warning"
                    @click="selectBranch(props.item.id)"
                    :disabled="props.item.archived"
                  >
                    {{ $t("custom.to_branch") }} ->
                  </v-btn>
                </td>
                <td class="text-center">
                  <v-btn v-if="props.item.id != company.id && !props.item.archived" icon :data-testid="`branch-delete-${props.item.id}`" @click="deleteItem(props.item)" small color="error" :loading="isLoadingDeleteItem && updated_branch_id == props.item.id">
                    <v-icon>
                      mdi-delete-forever
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="props.item.id != company.id && props.item.archived" icon @click="unarchiveItem(props.item)" small color="warning" :loading="isLoadingUnarchiveItem && updated_branch_id == props.item.id">
                    <v-icon>
                      mdi-restore
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              {{ $t("custom.no_data_in_table") }}
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="mdi-alert"
            >
              {{ $t("tables.no_search_result", { msg: search }) }}
            </v-alert>
          </v-data-table>
          <v-flex class="text-center">
            <v-btn
              class="mb-2"
              color="error"
              small
              @click="deleteMainCompany()"
              >{{ $t("companies.remove_all_info") }}</v-btn
            >
          </v-flex>
        </v-card>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="newBranchDialog"
      :retain-focus="false"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <h3 class="text-center w-full">
            {{ $t("custom.creating_branch") }}
            <br v-if="$store.getters.getMainCompany.plan && $store.getters.getMainCompany.plan.branches_limit > 0"><span v-if="$store.getters.getMainCompany.plan && $store.getters.getMainCompany.plan.branches_limit > 0" class="text-subtitle-1"><span :class="branches_count >= $store.getters.getMainCompany.plan.branches_limit ? 'error--text' : ''">{{ branches_count }}</span>/{{ $store.getters.getMainCompany.plan.branches_limit }}</span>
          </h3>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-text-field
            v-model.trim="branch.name"
            data-testid="branch-name-input"
            :label="$t('users.company_name')"
            :placeholder="$t('users.company_name_placeholder')"
          ></v-text-field>
          <v-autocomplete
            :label="$t('users.country')"
            v-model="branch.country"
            :items="countries"
            item-text="both"
            item-value="name"
          >
          </v-autocomplete>
          <v-text-field
            v-model.trim="branch.city"
            data-testid="branch-city-input"
            :label="$t('users.city')"
            :placeholder="$t('users.city_placeholder')"
          ></v-text-field>
          <v-text-field
            v-model.trim="branch.address"
            data-testid="branch-address-input"
            :label="$t('users.address')"
            :placeholder="$t('users.address_plc')"
          ></v-text-field>
          <v-autocomplete
            v-model="branch.locale"
            item-text="text"
            item-value="value"
            :items="locales"
            :label="$t('companies.notification_locale')"
            :placeholder="$t('companies.locale_plc')"
          ></v-autocomplete>
          <v-autocomplete
            v-model="branch.time_zone"
            item-text="text"
            item-value="value"
            :items="time_zones"
            :label="$t('users.time_zone')"
            :placeholder="$t('users.time_zone_placeholder')"
          ></v-autocomplete>
          <phone-field
            v-model="branch.phone"
            mode="soft"
            :default-country="phoneDefaultCountry"
            data-testid="branch-phone-input"
            :label="$t('users.phone')"
          />
          <v-text-field
            v-model="branch.email"
            data-testid="branch-email-input"
            :label="$t('users.email')"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text data-testid="branch-close-btn" @click="newBranchDialog = false">{{
            $t("custom.close")
          }}</v-btn>
          <v-btn color="success" data-testid="branch-save-btn" @click="submit()">{{
            $t("custom.save")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог подтверждения удаления филиала -->
    <v-dialog
      v-model="deleteDialog"
      :retain-focus="false"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <h3 class="text-center w-full error--text">
            {{ $t("custom.you_sure_title") }}
          </h3>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <p class="mt-4 text-body-1">{{ $t("branches.delete_branch") }}</p>
          <p class="mt-4 mb-2"><strong>{{ $t("branches.confirm_delete_text") }}:</strong></p>
          <p class="mb-4 font-weight-bold">"{{ branchToDelete ? branchToDelete.name : '' }}"</p>
          <v-text-field
            v-model="deleteConfirmName"
            data-testid="branch-delete-name-input"
            :label="$t('branches.enter_branch_name')"
            :error-messages="deleteNameError"
            outlined
            dense
            @input="validateDeleteName"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDelete">{{
            $t("custom.you_sure_no")
          }}</v-btn>
          <v-btn
            color="error"
            data-testid="branch-confirm-delete-btn"
            :disabled="!deleteNameValid || isLoading"
            :loading="isLoading"
            @click="confirmDelete"
          >{{
            $t("custom.you_sure_yes")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог подтверждения удаления главной компании -->
    <v-dialog
      v-model="deleteMainDialog"
      :retain-focus="false"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <h3 class="text-center w-full error--text">
            {{ $t("custom.you_sure_title") }}
          </h3>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <p class="mt-4 text-body-1">{{ $t("companies.remove_all_info_text") }}</p>
          <p class="mt-4 mb-2"><strong>{{ $t("branches.confirm_delete_main_text") }}:</strong></p>

          <div v-if="branches.length > 0" class="mb-4">
            <p class="mb-2 text-subtitle-2">{{ $t("branches.available_branches") }}:</p>
            <v-chip
              v-for="branch in branches"
              :key="branch.id"
              small
              class="ma-1"
              color="primary"
              outlined
            >
              {{ branch.name }}
            </v-chip>
          </div>

          <v-text-field
            v-model="deleteMainConfirmName"
            :label="$t('branches.enter_any_branch_name')"
            :error-messages="deleteMainNameError"
            outlined
            dense
            @input="validateDeleteMainName"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDeleteMain">{{
            $t("custom.you_sure_no")
          }}</v-btn>
          <v-btn
            color="error"
            :disabled="!deleteMainNameValid || isLoading"
            :loading="isLoading"
            @click="confirmDeleteMain"
          >{{
            $t("custom.you_sure_yes")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { countries } from "./../countries";
import { buildTimeZoneOptions } from "@/helpers/timezones";
import PhoneField from "@/components/common/PhoneField.vue";
import { defaultPhoneCountry } from "@/lib/phone/defaultCountry";
// moment.locale("ru");
export default {
  pullToRefresh: true,
  data() {
    return {
      branches: [],
      countries: countries,
      branch: {
        name: null,
        country: "Россия",
        city: null,
        address: null,
        phone: null,
        email: null,
        time_zone: "Europe/Moscow",
        locale: "ru",
      },
      headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.company_name"),
          value: "name",
          align: "center",
        },
        { text: this.$t("custom.country"), value: "country", align: "center" },
        { text: this.$t("custom.city"), value: "city", align: "center" },
        {
          text: this.$t("custom.address"),
          sortable: false,
          value: "address",
          align: "center",
        },
        {
          text: this.$t("custom.to_branch_2"),
          sortable: false,
          align: "center",
        },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
      ],
      time_zones: buildTimeZoneOptions(),
      locales: [
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      updated_branch_id: null,
      deleteNameValid: false,
      deleteMainDialog: false,
      deleteMainConfirmName: '',
      deleteMainNameError: '',
      deleteMainNameValid: false,
      editDialog: false,
      newBranchDialog: false,
      deleteDialog: false,
      branchToDelete: null,
      deleteConfirmName: '',
      deleteNameError: '',
      search: null,
      isMobile: false,
      isLoading: true,
      isLoadingUnarchiveItem: false,
      isLoadingDeleteItem: false,
      error: "",
    };
  },
  mounted() {
    let self = this;
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (this.$store.getters.isSuperAdmin || this.$store.getters.isGuest) {
        this.isLoading = true;
        this.axios
          .get("/api/v1/main_companies", {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.branches = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.branch_load"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$router.push({ path: `/dashboard` }).catch((err) => {});
        this.$notify(this.$t("errors.admins_only"), this.error, "error");
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  computed: {
    company() {
      return this.$store.getters.getCompany.company;
    },
    phoneDefaultCountry() {
      return defaultPhoneCountry({ client: this.branch, company: this.company });
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    branches_count() {
      return this.branches.filter(b => !b.archived).length;
    }
  },
  methods: {
    submit() {
      if(this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.branches_limit > 0 && this.branches_count >= this.$store.getters.getMainCompany.plan.branches_limit) {
        this.$notify(this.$t('plans.branches_limit_reached_title'), this.$t('plans.branches_limit_reached_text'), "warning");
        return;
      } else {
        // проверяем на должника
        if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
          this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
          return;
        }
        if (this.isStaff) {
          let branch = this.branch;
          let self = this;
          if (
            branch.name &&
            branch.country &&
            branch.city &&
            branch.address &&
            branch.email &&
            branch.phone
          ) {
            this.isLoading = true;
            this.axios
              .post(
                "/api/v1/create_company",
                {
                  name: branch.name,
                  country: branch.country,
                  city: branch.city,
                  time_zone: branch.time_zone,
                  locale: branch.locale,
                  address: branch.address,
                  email: branch.email,
                  phone: branch.phone,
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then((response) => {
                let data = response.data;
                this.branches.push(data);
                this.newBranchDialog = false;
                this.$notify(this.$t("branches.added"), "", "success");
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.add_branch"));
              })
              .finally(() => (this.isLoading = false));
          } else {
            this.$notify(this.$t("errors.all_fields_title"), this.$t("errors.all_fields_text_2"), "warning", 4000);
          }
        } else {
          this.$notify(this.$t("errors.no_access"), "", "warning");
        }
      }
    },
    selectBranch(id) {
      let self = this;
      this.isLoading = true;
      this.axios
        .post(
          "/api/v1/select_company",
          {
            id: id,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.$store.commit("setCompany", { company: response.data });
          self.axios
            .get("/me.json", {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.$store.commit("setCurrentUser", response.data);
            })
            .catch(function (error) {
              self.$store.commit("unsetCurrentUser");
              self.isLoading = false;
              self.setError(error, self.$t("errors.error"));
              // self.$router.push({ path: `/signin` }).catch(err => {});
              console.log(error);
            });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.change_branch"));
        })
        .finally(() => (this.isLoading = false));
    },
    unarchiveItem(branch) {
      if (!this.isSuperAdmin) {
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      this.updated_branch_id = branch.id;
      this.isLoadingUnarchiveItem = true;
      this.axios
        .post(`/api/v1/unarchive_company`,
          {
            company_id: branch.id,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.branches.find(b => b.id == branch.id).archived = false;
          this.branches = this.branches.map(b => b.id == branch.id ? { ...b, archived: false } : b);
          this.$notify(this.$t("custom.unarchived"), this.$t("branches.unarchive_success"), "success");
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.unarchive_branch"));
        })
        .finally(() => (this.isLoadingUnarchiveItem = false, this.updated_branch_id = null));
    },
    deleteItem(branch) {
      if (this.isSuperAdmin) {
        this.branchToDelete = branch;
        this.deleteConfirmName = '';
        this.deleteNameError = '';
        this.deleteNameValid = false;
        this.deleteDialog = true;
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    validateDeleteName() {
      if (!this.deleteConfirmName) {
        this.deleteNameError = this.$t("branches.name_required");
        this.deleteNameValid = false;
      } else if (this.deleteConfirmName !== this.branchToDelete.name) {
        this.deleteNameError = this.$t("branches.name_mismatch");
        this.deleteNameValid = false;
      } else {
        this.deleteNameError = '';
        this.deleteNameValid = true;
      }
    },
    cancelDelete() {
      this.deleteDialog = false;
      this.branchToDelete = null;
      this.deleteConfirmName = '';
      this.deleteNameError = '';
      this.deleteNameValid = false;
    },
    confirmDelete() {
      if (this.deleteNameValid && this.branchToDelete) {
        this.updated_branch_id = this.branchToDelete.id;
        this.isLoadingDeleteItem = true;
        this.axios
          .delete(`/api/v1/destroy_company/${this.branchToDelete.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then(() => {
            // this.branches.splice(this.branches.indexOf(this.branchToDelete), 1);
            this.branches = this.branches.map(b => b.id == this.branchToDelete.id ? { ...b, archived: true } : b);
            this.$notify(this.$t("custom.deleted"), this.$t("branches.delete_success"), "success");
            this.cancelDelete();
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.delete_branch"));
          })
          .finally(() => (this.isLoadingDeleteItem = false, this.updated_branch_id = null));
      }
    },
    deleteMainCompany() {
      if (this.isSuperAdmin) {
        this.deleteMainConfirmName = '';
        this.deleteMainNameError = '';
        this.deleteMainNameValid = false;
        this.deleteMainDialog = true;
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    validateDeleteMainName() {
      if (!this.deleteMainConfirmName) {
        this.deleteMainNameError = this.$t("branches.name_required");
        this.deleteMainNameValid = false;
      } else {
        // Проверяем, что введенное название совпадает с одним из филиалов
        const branchExists = this.branches.some(branch => branch.name === this.deleteMainConfirmName);
        if (!branchExists) {
          this.deleteMainNameError = this.$t("branches.branch_not_found");
          this.deleteMainNameValid = false;
        } else {
          this.deleteMainNameError = '';
          this.deleteMainNameValid = true;
        }
      }
    },
    cancelDeleteMain() {
      this.deleteMainDialog = false;
      this.deleteMainConfirmName = '';
      this.deleteMainNameError = '';
      this.deleteMainNameValid = false;
    },
    confirmDeleteMain() {
      if (this.deleteMainNameValid) {
        this.isLoading = true;
        this.axios
          .delete(`/api/v1/destroy_main_company`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then(() => {
            this.$store.commit("unsetCurrentUser");
            this.cancelDeleteMain();
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.delete_branch"));
          })
          .finally(() => (this.isLoading = false));
      }
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("LL");
    },
    checkSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: { PhoneField },
};
</script>
